<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

</style>
<style>
.el-table .cell{
  white-space: pre-line;
}
</style>
<template>
  <div class="content">
    <div class="search-area" style="margin-bottom: 0;">
      <img src="../../assets/images/logo-fbt.png" alt="" srcset="" width=294 >
      <div v-if="tableData.length !=0" style="color:#818181;margin-top:14px">当前版本：{{tableData[0].versionNo}}</div>
      <div v-else style="color:#818181;margin-top:14px">当前版本：暂无版本信息</div>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="padding:0 20px">
      <el-table :data="tableData" stripe border   v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="left" >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" width="150"  label="版本号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.versionNo }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" show-overflow-tooltip  label="说明"  header-align="center" align="left">
          <template slot-scope="scope" >{{ scope.row.versionDesc }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" width="100" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateDate | getDate }}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '发布版本',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizState: 'Y',
        versionNo: '',
        identifier: 'scm_operative',
      },
      appSideGuid: '',
      versionNo: '',
      versionDesc: '',
      bizState: 'Y',
      articleId: '',
      tableLoading: false,
      appSideGuidList: [],
      bizStateList: [
        {
          label: '上架',
          value: 'Y',
        },
        {
          label: '下架',
          value: 'N',
        },
      ],
      height: window.innerHeight - 280,
      right: 'right',
      tableData: [],
    };
  },
  created() {
    this.getAppSideGuidList();
    this.getList();
  },
  watch: {},
  methods: {
    getList() {
      let self = this;
      self.api.get(`/${serverConfig.msConfigureService}/version/list`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAppSideGuidList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.appSideGuidList = res.data.data.records;
        }
      });
    },
    getAppSideName(guid) {
      var appSideGuidList = this.appSideGuidList;
      var item = appSideGuidList.filter((item) => item.guid == guid);
      if (item.lenght == 0) return;
      return item[0].appSideName;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>